import React from "react";

export function ZipIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 45.97 44.24"
      width="30"
      height="30"
      {...props}
    >
      <path
        className="cls-1"
        d="m23.42,38.53l-.4-.55c-.52-.72-12.82-17.65-12.82-24.76S16.13,0,23.42,0s13.22,5.93,13.22,13.22-12.29,24.04-12.82,24.76l-.4.55Zm0-37.53c-6.74,0-12.22,5.48-12.22,12.22,0,6.09,10.06,20.57,12.22,23.6,2.16-3.04,12.22-17.52,12.22-23.6,0-6.74-5.48-12.22-12.22-12.22Z"
      />
      <path
        className="cls-1"
        d="m23.42,19.59c-3.78,0-6.86-3.08-6.86-6.86s3.08-6.86,6.86-6.86,6.86,3.08,6.86,6.86-3.08,6.86-6.86,6.86Zm0-12.72c-3.23,0-5.86,2.63-5.86,5.86s2.63,5.86,5.86,5.86,5.86-2.63,5.86-5.86-2.63-5.86-5.86-5.86Z"
      />
      <path
        className="cls-1"
        d="m22.98,44.24c-11.14,0-22.98-1.99-22.98-5.69,0-3.09,8.16-4.83,15.79-5.42l.08,1c-9.65.75-14.86,2.84-14.86,4.42,0,2.22,9.03,4.69,21.98,4.69s21.98-2.47,21.98-4.69c0-1.52-4.7-3.49-13.67-4.32l.09-1c3.42.32,14.58,1.63,14.58,5.32s-11.84,5.69-22.98,5.69Z"
      />
    </svg>
  );
}
